export default __webpack_public_path__ + "static/media/logo9.3acb4eb8.png";